import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Home } from './pages/Home';
import { GameSelector } from './pages/GameSelector';
import { MafiaLanding } from './pages/MafiaLanding';
import { CreateRoom } from './pages/CreateRoom';
import { Room } from './pages/Room';
import { JoinByCode } from './pages/JoinByCode';
import { ZayacLanding } from './pages/ZayacLanding';
import { CreateZayacRoom } from './pages/CreateZayacRoom';
import { ZayacRoom } from './pages/ZayacRoom';
import { BunkerLanding } from './pages/BunkerLanding';
import { CreateBunkerRoom } from './pages/CreateBunkerRoom';
import { BunkerRoom } from './pages/BunkerRoom';
import { BunkerSharedScreen } from './pages/BunkerSharedScreen';
import { AliasLanding } from './pages/AliasLanding';
import { CreateAliasRoom } from './pages/CreateAliasRoom';
import { AliasRoom } from './pages/AliasRoom';
import { AliasSharedScreen } from './pages/AliasSharedScreen';
import { Quizzes } from './pages/Quizzes';
import { QuizPlay } from './pages/QuizPlay';
import { QuizLive } from './pages/QuizLive';
import { QuizRoomLive } from './pages/QuizRoomLive';
import { ComingSoon } from './pages/ComingSoon';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/play" element={<GameSelector />} />
      <Route path="/play/mafia" element={<MafiaLanding />} />
      <Route path="/play/mafia/create" element={<CreateRoom />} />
      <Route path="/room/:code" element={<Room />} />
      <Route path="/r/:code" element={<RedirectToRoom />} />
      <Route path="/play/zayac" element={<ZayacLanding />} />
      <Route path="/play/zayac/create" element={<CreateZayacRoom />} />
      <Route path="/zayac/:code" element={<ZayacRoom />} />
      <Route path="/z/:code" element={<RedirectToZayac />} />
      <Route path="/play/bunker" element={<BunkerLanding />} />
      <Route path="/play/bunker/create" element={<CreateBunkerRoom />} />
      <Route path="/bunker/:code/screen" element={<BunkerSharedScreen />} />
      <Route path="/bunker/:code" element={<BunkerRoom />} />
      <Route path="/b/:code/screen" element={<BunkerSharedScreen />} />
      <Route path="/b/:code" element={<RedirectToBunker />} />
      <Route path="/play/alias" element={<AliasLanding />} />
      <Route path="/play/alias/create" element={<CreateAliasRoom />} />
      <Route path="/alias/:code/screen" element={<AliasSharedScreen />} />
      <Route path="/alias/:code" element={<AliasRoom />} />
      <Route path="/a/:code/screen" element={<AliasSharedScreen />} />
      <Route path="/a/:code" element={<RedirectToAlias />} />
      <Route path="/rooms" element={<JoinByCode />} />
      <Route path="/quizzes" element={<Quizzes />} />
      <Route path="/quiz/:quizId" element={<QuizPlay />} />
      <Route path="/quiz-live" element={<QuizLive />} />
      <Route path="/quiz-room/:code" element={<QuizRoomLive />} />
      <Route path="/q/:code" element={<RedirectToQuizRoom />} />
      <Route path="/play/:gameId" element={<ComingSoonRoute />} />
      <Route path="*" element={<ComingSoon title="404" />} />
    </Routes>
  );
}

function RedirectToRoom() {
  const { code } = useParams();
  return <Navigate to={code ? `/room/${code}` : '/rooms'} replace />;
}

function RedirectToZayac() {
  const { code } = useParams();
  return <Navigate to={code ? `/zayac/${code}` : '/rooms'} replace />;
}

function RedirectToBunker() {
  const { code } = useParams();
  return <Navigate to={code ? `/bunker/${code}` : '/rooms'} replace />;
}

function RedirectToAlias() {
  const { code } = useParams();
  return <Navigate to={code ? `/alias/${code}` : '/rooms'} replace />;
}

function RedirectToQuizRoom() {
  const { code } = useParams();
  return <Navigate to={code ? `/quiz-room/${code}` : '/quiz-live'} replace />;
}

function ComingSoonRoute() {
  return <ComingSoon title="Скоро" />;
}
